import ProficienciesPaneProficiencyEditor from "./ProficienciesPaneProficiencyEditor";

export default ProficienciesPaneProficiencyEditor;
export { ProficienciesPaneProficiencyEditor };
